/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SubmitAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaModalFooterAction from 'DesignSystem/TysiaModal/TysiaModalFooter/TysiaModalFooterAction/index'



/** @type {import('Simple/types.js').View} */
export default function SubmitAction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Send/Content/SubmitAction",
  onSubmit,
  isDisabled
  
}) {
let treatmentPlanRequestSubmitData = fromData.useDataSubmit({ viewPath,
context: 'treatment_plan_request',
})
  return (<React.Fragment
>
<TysiaModalFooterAction
  viewPath={`${viewPath}/TysiaModalFooterAction`}
 type="primary"
 size="normal"
 data="treatment_plan_request"
 onClick={treatmentPlanRequestSubmitData}
 disabled={isDisabled}
 text="Send case closer request"
/>
{children}
</React.Fragment>)
}